import { ArcadeHudInterface } from './Interface';
import type { ArcadeHudViewProps } from './types';

/** Thin container — HUD state/handlers live in the app shell for now. */
export default function ArcadeHudContainer(props: ArcadeHudViewProps) {
  return <ArcadeHudInterface {...props} />;
}
